namespace app.model.metrics {
  export class ProcessingMetrics {
    public readonly size: any;
    public readonly count: any;

    constructor(size: angular.resource.IResourceService, count: angular.resource.IResourceService, resourceWrapperService: app.services.utilities.ResourceWrapperService) {
      this.size = resourceWrapperService.WrapActions(size);
      this.count = resourceWrapperService.WrapActions(count);
    }
  }
}

// Expose as browser global so cross-module bare references (new ProcessingMetrics(...)) resolve
(window as any).ProcessingMetrics = app.model.metrics.ProcessingMetrics;
